import styled from "@emotion/styled";
import type { UserListItemDto } from "Infrastructure/Api/Api";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { BlDefaultButton } from "Shared/Buttons/BlDefaultButton";
import { getDefaultTableOptions } from "Shared/DataTable/MaterialReactTable";
import { ExpandArrowIcon } from "Shared/Icons";
import { useUsersQuery } from "Users/Api/Queries/useUsersQuery";
import {
	MaterialReactTable,
	createMRTColumnHelper,
	useMaterialReactTable,
} from "material-react-table";
import { useNavigate } from "react-router-dom";

const StyledButton = styled(BlDefaultButton)`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;

  svg {
    color: ${(props) => props.theme.palette.text.secondary};
    width: 12px;
    height: auto;
    transform: rotate(-90deg);
  }
`;

type Props = {};

export const UsersTable2: React.FunctionComponent<Props> = () => {
	const { data, isLoading } = useUsersQuery();

	const clients: UserListItemDto[] = data?.items ?? [];

	const navigate = useNavigate();

	const columnHelper = createMRTColumnHelper<UserListItemDto>();

	const table = useMaterialReactTable({
		...getDefaultTableOptions<UserListItemDto>(),
		columns: [
			columnHelper.accessor("userID", {
				header: "ID",
				size: 25,
			}),
			columnHelper.accessor("firstName", {
				header: "Jméno",
				size: 50,
			}),
			columnHelper.accessor("lastName", {
				header: "Příjmení",
				size: 50,
			}),
			columnHelper.accessor("login", {
				header: "Login",
				size: 100,
			}),
			{
				id: "action",
				header: "",
				Cell: ({ row }) => (
					<StyledButton
						onClick={() => {
							navigate(AppRouting.UserDetail.path(row.original.userID));
						}}
					>
						<ExpandArrowIcon />
					</StyledButton>
				),
			},
		],
		data: clients,
		enableTopToolbar: false,
		enableBottomToolbar: false,
		state: {
			isLoading,
		},
	});

	return (
		<>
			<MaterialReactTable table={table} />
		</>
	);
};
